import React, { Component } from 'react';
import AccountMenu from '../Modules/AccountMenu'
import ChangePassword from '../Modules/Account/WachtwoordWijzigen'


class WachtwoordWijzigen extends Component {

    render() {
        return (
            <div className="route">
                <AccountMenu />
                <div className="grey-bg">
                    <h1 className="pageTitle">
                        MAIL- EN WACHTWOORD WIJZIGEN
                    </h1>
                    <ChangePassword />
                </div>
            </div>
        );
    }
}

export default WachtwoordWijzigen;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/WachtwoordWijzigen.js